export const BUSINESSQUERIESMANAGEMENT_FILE = 'BUSINESSQUERIESMANAGEMENT_FILE';
// 更新
export const BUSINESSQUERIESMANAGEMENT_UPDATE = 'BUSINESSQUERIESMANAGEMENT_UPDATE';
